<template>
  <v-app :theme="currentTheme" class="app-shell">
    <img src="./assets/gerb.svg" class="app-logo mt-3 ml-3" alt="Герб"/>
    <header class="app-header pl-3">
      <button
        type="button"
        class="theme-toggle"
        :aria-label="themeToggleLabel"
        :title="themeToggleLabel"
        @click="toggleTheme"
      >
        <span class="mdi" :class="themeToggleIcon" aria-hidden="true"></span>
      </button>

      <div class="info mr-5">
        <!-- <a href="https://192.168.0.92/iasu" class="mr-5 isau"> -->
        <a :href="getConfig?.iasuUrl" class="mr-5 isau">
          <span class="mdi mdi-arrow-left"></span>Назад в ИАСУ WEB</a>
        <p v-if="getUserData"><span class="mdi mdi-account"></span> {{
            getUserData?.lastName + ' ' +
            getUserData?.firstName?.[0] + '.' +
            (getUserData?.secondName ? getUserData.secondName[0] + '.' : '')
          }}
        </p>
        <p v-else>Ошибка авторизации</p>
      </div>
    </header>

    <main class="app-content">
      <router-view/>
    </main>

    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import requestService from './services/request.service'
import {
  applyThemeToDocument,
  DARK_THEME,
  getInitialTheme,
  LIGHT_THEME,
  saveTheme,
} from './utils/theme'

export default {
  name: 'App',

  data() {
    return {
      userData: null,
      currentTheme: getInitialTheme(),
    }
  },

  computed: {
    ...mapGetters(['getUserData', 'getConfig']),

    snackbarShow: {
      get() {
        return this.$store.state.show
      },
      set() {
        this.$store.commit('CLOSE')
      }
    },

    snackbarText() {
      return this.$store.state.text
    },

    snackbarColor() {
      return this.$store.state.color
    },

    snackbarTimeout() {
      return this.$store.state.timeout
    },

    isDarkTheme() {
      return this.currentTheme === DARK_THEME
    },

    themeToggleIcon() {
      return this.isDarkTheme ? 'mdi-weather-sunny' : 'mdi-weather-night'
    },

    themeToggleLabel() {
      return this.isDarkTheme ? 'Включить светлую тему' : 'Включить тёмную тему'
    }
  },

  methods: {
    toggleTheme() {
      this.currentTheme = this.isDarkTheme ? LIGHT_THEME : DARK_THEME
      saveTheme(this.currentTheme)
      applyThemeToDocument(this.currentTheme)
    },

    toPlicante() {
      window.location.href = `https://apk-plicante.lenobl.ru/?aistoken=Bearer ${localStorage.getItem('token')}`
    },
    getToken() {
      const urlParams = new URLSearchParams(window.location.search)
      const token = urlParams.get('token')

      if (token) {
        localStorage.setItem('token', token)
        this.validateBearer()
      } else if (localStorage.getItem('token')) {
        this.validateBearer()
      } else {
        console.log("Ошибка при получении токена")
      }
    },

    validateBearer() {
      const url = `${process.env.VUE_APP_BASE_URL}/v3/validateBearer`
      requestService.get(url)
        .then(data => {
          this.$store.commit('SET_USER_DATA', data.data)
        })
        .catch(() => {
          console.log('Ошибка при валидации токена')
        })
    }
  },

  mounted() {
    this.getToken();
  }
}
</script>

<style lang="scss">
@import './assets/scss/main.scss';
.app-header {
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  background: var(--app-header);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: var(--app-text);
  border-bottom: 1px solid var(--app-border);
  box-shadow: 0 2px 12px var(--app-shadow);
  position: fixed;
  z-index: 100;
  top: 0;
  transition: background-color 180ms ease, color 180ms ease, border-color 180ms ease;
}

.app-logo {
  width: 48px;
  height: 42px;
  position: fixed;
  top: 0;
  z-index: 1000;
}

.app-content {
  min-height: 100vh;
  background: var(--app-background);
  color: var(--app-text);
}

.theme-toggle {
  width: 38px;
  height: 38px;
  margin-right: 18px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  cursor: pointer;
  font-size: 21px;
  transition: background-color 150ms ease, border-color 150ms ease, transform 150ms ease;
}

.theme-toggle:hover {
  background: var(--app-hover);
  border-color: var(--app-primary);
}

.theme-toggle:active {
  transform: scale(0.94);
}

.theme-toggle:focus-visible {
  outline: 2px solid var(--app-primary);
  outline-offset: 2px;
}

.info {
  display: flex;
  align-items: center;
}

.info p {
  margin-top: 0;
  margin-bottom: 0;
}

.isau {
  text-decoration: none;
  color: var(--app-text);
}

.isau:hover {
  color: var(--app-primary);
}

@media (max-width: 480px) {
  .app-header {
    padding-left: 68px !important;
  }

  .app-logo {
    width: 38px;
    height: 40px;
    margin-left: 10px !important;
  }

  .theme-toggle {
    width: 36px;
    height: 36px;
    margin-right: 8px;
    border-radius: 9px;
    font-size: 20px;
  }

  .info {
    min-width: 0;
    margin-right: 8px !important;
  }

  .info p {
    max-width: 92px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px;
  }

  .isau {
    margin-right: 8px !important;
    font-size: 0;
  }

  .isau .mdi {
    font-size: 22px;
  }
}
</style>
